module.exports = __webpack_public_path__ + "static/media/hotel_lobby_zoomed.0fcbc9d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/hotel_lobby_zoomed.jpg
// module id = 2391
// module chunks = 0